import React from 'react'
import { GButton, GCheckBox } from 'tennders-common/form/components'
import {
  CarrierCompanyInfo,
  DeliveryLocation,
  FullAddress,
  LoadDetails,
  OrderNo,
  PaymentDetails,
  PickupLocation,
  TruckDetails
} from 'tennders-documents/components/orderDocumentForm'
import useTranslation from 'next-translate/useTranslation'
import useTruckTypes from 'tennders-market/truck/hooks/useTruckTypes'
import useOrderDocumentForm from 'tennders-documents/hooks/useOrderDocumentForm'
import GLoading from 'tennders-market/common/components/element/GLoading'
import { ReactSVG } from 'react-svg'

const OrderDocumentForm = () => {
  const { t } = useTranslation()
  const { trucktypes } = useTruckTypes()
  const {
    handleSubmit,
    form,
    errors,
    submitting,
    onChange,
    loading,
    setcopy,
    copy,
    pickupStops,
    removePickupStop,
    getMinPickupDate,
    addPickupStop,
    getMinDeliveryRouteDate,
    setPickupStops,
    deliveryStops,
    removeDeliveryStop,
    getMinDeliveryDate,
    setDeliveryStops,
    addDeliveryStop
  } = useOrderDocumentForm()

  return (
    <>
      {loading
        ? (
          <div className="d-flex" style={{ minHeight: '500px' }}>
            <GLoading size={72} />
          </div>
        )
        : (
          <>
            <div className="d-flex align-center mb-24">
              <h3 className="bold mr-60 mb-0">{t('document:orderConfirmationForCarrier')}</h3>
              <GCheckBox onSet={setcopy} value={copy}>{t('document:copyOrderDoc')}</GCheckBox>
            </div>
            <div className="d-flex mb-20">
              <div className="w-50">
                <div className="pt-20 pr-20">
                  <PickupLocation
                    form={form}
                    errors={errors}
                    onChange={onChange}
                    pickupStops={pickupStops}
                    removePickupStop={removePickupStop}
                    getMinPickupDate={getMinPickupDate}
                    setPickupStops={setPickupStops}
                    addPickupStop={addPickupStop}
                  />
                </div>

              </div>
              <div className="w-50">
                <div className="pt-20 pr-20">
                  <DeliveryLocation
                    form={form}
                    errors={errors}
                    onChange={onChange}
                    getMinDeliveryRouteDate={getMinDeliveryRouteDate}
                    deliveryStops={deliveryStops}
                    removeDeliveryStop={removeDeliveryStop}
                    getMinDeliveryDate={getMinDeliveryDate}
                    setDeliveryStops={setDeliveryStops}
                    addDeliveryStop={addDeliveryStop}
                  />
                </div>
              </div>
            </div>
            <div className="hr" />
            <div>
              <h4 className="bold mb-0">{t('document:carrierCompanyInfo')}</h4>
              <div className="d-flex">
                <div className="w-50">
                  <div className="pt-20 pb-20 pr-20">
                    <CarrierCompanyInfo
                      form={form}
                      disabled
                      errors={errors}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className="w-50">
                  <div className="pt-20 pb-20 pr-20">
                    <FullAddress
                      form={form}
                      errors={errors}
                      onChange={onChange}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="hr" />
              <div className="d-flex">
                <div className="w-50">
                  <div className="pt-20 pr-20">
                    <TruckDetails
                      form={form}
                      errors={errors}
                      onChange={onChange}
                      truckTypes={trucktypes}
                    />
                  </div>
                </div>
                <div className="w-50">
                  <div className="pt-20 pr-20">
                    <LoadDetails
                      form={form}
                      errors={errors}
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>
              <div className="hr" />
              <div className="d-flex">
                <div className="w-50">
                  <div className="pt-20 pr-20">
                    <PaymentDetails
                      form={form}
                      errors={errors}
                      disabled
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className="w-50">
                  <div className="pt-20 pr-20">
                    <OrderNo
                      form={form}
                      errors={errors}
                      onChange={onChange}
                      isOrderNoDisabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="hr" />
            <div className="d-flex align-center justify-end pb-32">
              <GCheckBox
                className="d-flex align-center mr-6"
                name="sendToCarrierAfter"
                form={form}
                onChange={onChange}
              >
                {t('document:orderDocSubMsg')}
              </GCheckBox>
              <GButton
                submitting={submitting}
                onClick={handleSubmit}
                className="btn highlighted-btn bold ml-10"
              >
                <ReactSVG
                  src="/icons/add-docs.svg"
                  className="btn-icon-wrapper"
                  beforeInjection={(svg) => {
                    svg.classList.add('btn-icon')
                  }}
                />
                {t('document:generatePDF')}
              </GButton>
            </div>
          </>
        )}
    </>
  )
}
export default OrderDocumentForm
